export default "__VITE_ASSET__BQKL5jLC__"